import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsUnterseiteMobil(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 352.73 81.39"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M87.69 32.38c-1.3 0-2.56.18-3.78.47l-6.53-15.54 5.97-.15c.24.04 1.29.24 1.79 1 .4.61.42 1.51.04 2.7-.21.66.15 1.36.81 1.57.66.21 1.36-.15 1.57-.81.62-1.94.51-3.57-.34-4.85-1.23-1.84-3.46-2.09-3.71-2.11h-.14l-7.89.2c-.41.01-.79.22-1.02.57-.22.35-.26.78-.1 1.16l2.76 6.57-28.47.36-1.91-4.06h5.79c1.04 0 1.87-.84 1.87-1.87s-.84-1.87-1.87-1.87H39.51c-1.04 0-1.87.84-1.87 1.87s.84 1.87 1.87 1.87h4.47l2.31 4.9-6.38 10.04a15.714 15.714 0 0 0-7.73-2.03c-8.74 0-15.85 7.11-15.85 15.85s7.11 15.85 15.85 15.85 15.42-6.71 15.81-15.1l9.86-.04 1.52 3.22c-.56.38-.92 1.03-.92 1.75 0 1.17.95 2.13 2.13 2.13h1.78c1.17 0 2.13-.95 2.13-2.13s-.95-2.13-2.13-2.13h-.39l-1.8-3.82L78.6 26.63l2.94 6.99c-5.69 2.41-9.69 8.05-9.69 14.6 0 8.74 7.11 15.85 15.85 15.85s15.85-7.11 15.85-15.85-7.11-15.85-15.85-15.85Zm-55.51 29.2c-7.36 0-13.35-5.99-13.35-13.35s5.99-13.35 13.35-13.35c2.32 0 4.49.59 6.4 1.64l-6.73 10.6c-.25.39-.26.87-.04 1.27s.64.65 1.09.65l12.59-.05c-.4 7.01-6.21 12.59-13.31 12.59ZM45.4 46.49l-10.22.04 5.47-8.61c2.55 2.1 4.3 5.13 4.75 8.57Zm2.52 0c-.48-4.32-2.7-8.11-5.94-10.67l5.56-8.76 9.13 19.39-8.75.03Zm11.07-.99-9.16-19.47 26.28-.33-17.12 19.8Zm28.7 16.09c-7.36 0-13.35-5.99-13.35-13.35 0-5.52 3.37-10.27 8.16-12.3l5.19 12.34c.2.48.67.77 1.15.77.16 0 .33-.03.48-.1.64-.27.94-1 .67-1.64l-5.1-12.12c.9-.19 1.84-.3 2.8-.3 7.36 0 13.35 5.99 13.35 13.35s-5.99 13.35-13.35 13.35Z"
        style={{
          fill: '#34c17b',
        }}
      />
      <g data-name="Mobilit\xE4t Sammlung Desktop">
        <path
          d="M147.38 23.08v36.36h5.22V33.11h.34l10.72 26.28h4.33l10.72-26.26h.34v26.31h5.22V23.08h-6.66l-11.58 28.26h-.43l-11.58-28.26h-6.65Zm56.18 36.91c7.69 0 12.71-5.63 12.71-14.06s-5.03-14.12-12.71-14.12-12.71 5.63-12.71 14.12 5.02 14.06 12.71 14.06Zm.02-4.46c-5.03 0-7.37-4.39-7.37-9.62s2.34-9.66 7.37-9.66 7.33 4.44 7.33 9.66c0 5.24-2.35 9.62-7.33 9.62Zm19.26 3.91h5.18V55.2h.44a8.335 8.335 0 0 0 7.88 4.78c6.61 0 11.4-5.29 11.4-14.12s-4.86-14.05-11.45-14.05a8.173 8.173 0 0 0-7.83 4.78h-.32V23.08h-5.31v36.36Zm5.2-13.64c0-5.7 2.49-9.48 7.12-9.48s7.23 4.07 7.23 9.48c0 5.47-2.48 9.64-7.22 9.64s-7.12-3.9-7.12-9.64Zm25.89 13.64h5.31V32.17h-5.31v27.27Zm2.68-31.48c1.79.04 3.29-1.37 3.36-3.16a3.305 3.305 0 0 0-3.36-3.18c-1.8-.04-3.3 1.38-3.36 3.18.06 1.8 1.56 3.21 3.36 3.16Zm15.31-4.88h-5.31v36.36h5.31V23.08Zm7.37 36.36h5.31V32.17h-5.31v27.27Zm2.68-31.48c1.79.04 3.29-1.37 3.36-3.16a3.305 3.305 0 0 0-3.36-3.18c-1.8-.04-3.3 1.38-3.36 3.18.06 1.8 1.56 3.21 3.36 3.16Zm22.73 4.21h-5.59v-6.53h-5.31v6.53h-4v4.26h4v16.1c-.02 4.95 3.76 7.35 7.96 7.26 1.17.01 2.34-.18 3.45-.57l-.96-4.38c-.61.14-1.24.22-1.86.23-1.72 0-3.27-.57-3.27-3.64v-15h5.59v-4.26Zm14.03 27.87c4.51 0 7.05-2.29 8.06-4.33h.21v3.73h5.18V41.33c0-7.94-6.25-9.52-10.58-9.52-4.94 0-9.48 1.99-11.26 6.96l4.99 1.14c.78-1.93 2.77-3.8 6.34-3.8s5.18 1.79 5.18 4.88v.12c0 1.93-1.99 1.9-6.89 2.47-5.17.6-10.46 1.95-10.46 8.15 0 5.36 4.03 8.31 9.21 8.31Zm1.15-4.26c-3 0-5.17-1.35-5.17-3.98 0-2.84 2.52-3.85 5.59-4.26 1.72-.23 5.81-.69 6.57-1.46v3.52c0 3.23-2.58 6.18-7 6.18Zm-3.22-27.89c1.72 0 3.11-1.37 3.12-3.09a3.06 3.06 0 0 0-3.01-3.11h-.12c-1.72 0-3.12 1.38-3.14 3.11.06 1.7 1.44 3.06 3.14 3.09Zm10.44 0c1.72 0 3.11-1.37 3.12-3.09a3.06 3.06 0 0 0-3.01-3.11h-.12c-1.72 0-3.12 1.38-3.14 3.11.06 1.7 1.44 3.06 3.15 3.09Zm25.11 4.28h-5.59v-6.53h-5.31v6.53h-4v4.26h4v16.1c-.02 4.95 3.76 7.35 7.96 7.26 1.17.01 2.34-.18 3.45-.57l-.96-4.38c-.61.14-1.24.22-1.86.23-1.72 0-3.27-.57-3.27-3.64v-15h5.59v-4.26Z"
          data-name="Themen im Fokus-3"
          style={{
            fill: '#005096',
          }}
        />
        <g data-name="Gruppe 494">
          <rect
            height={81.39}
            rx={40.7}
            ry={40.7}
            style={{
              fill: 'none',
            }}
            width={120.15}
          />
          <rect
            height={78.89}
            rx={39.45}
            ry={39.45}
            style={{
              stroke: '#34c17b',
              strokeMiterlimit: 10,
              strokeWidth: '2.5px',
              fill: 'none',
            }}
            width={117.65}
            x={1.25}
            y={1.25}
          />
        </g>
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsUnterseiteMobil
